export const app = {
  version: '3.2.2',
  files: [
    '/',
    '/icon.png',
    '/index.css',
    '/index.js',
  ],
};
